/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'src/app/api';
import { buildEncodedQueryString } from 'src/common/utils';
import { DataFeed, FetchUserPreferencesPayload, SaveUserPreferencesPayload, UserPreferencesDto } from '.';
import { stampLatestPreferencesVersion } from './preferences/migrations';

export enum TemplateUserActionTypes {
  FetchDataFeeds = '@@store/userSettings/FetchDataFeeds',
  FetchUserPreferences = '@@store/userSettings/FetchUserPreferences',
  SaveUserPreferences = '@@store/userSettings/SaveUserPreferences',
}

export enum TemplateUserApiEndpoints {
  FetchDataFeeds = '/feedmanager/GetAdviserFeeds',
  GetUserPreferences = '/users/preferences',
}

export const fetchDataFeeds = createAsyncThunk<DataFeed[]>(TemplateUserActionTypes.FetchDataFeeds, async () => {
  const response = await api.post<DataFeed[]>(TemplateUserApiEndpoints.FetchDataFeeds);

  return response.data.map<DataFeed>((a) => ({ adviserId: a.adviserId, vendor: a.vendor, isRegistered: a.isRegistered }));
});

export const fetchUserPreferences = createAsyncThunk<UserPreferencesDto, FetchUserPreferencesPayload>(
  TemplateUserActionTypes.FetchUserPreferences,
  async ({ path }) => {
    const queryString = buildEncodedQueryString({ path });
    const response = await api.get<UserPreferencesDto>(`${TemplateUserApiEndpoints.GetUserPreferences}${queryString}`);
    return response.data;
  }
);

export const saveUserPreferences = createAsyncThunk<UserPreferencesDto, SaveUserPreferencesPayload>(
  TemplateUserActionTypes.SaveUserPreferences,
  async ({ entityId, path, preferences }) => {
    const stamped = stampLatestPreferencesVersion(path, preferences);
    const queryString = buildEncodedQueryString({ path });
    const response = await api.post<UserPreferencesDto>(`/users/${entityId}/preferences${queryString}`, stamped);
    return response.data;
  }
);
